var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12H7C9.20914 12 11 13.7909 11 16V18C11 20.2091 9.20914 22 7 22H6C3.79086 22 2 20.2091 2 18V16C2 13.7909 3.79086 12 6 12ZM6 14C4.89543 14 4 14.8954 4 16V18C4 19.1046 4.89543 20 6 20H7C8.10457 20 9 19.1046 9 18V16C9 14.8954 8.10457 14 7 14H6ZM5.5 2C7.433 2 9 3.567 9 5.5V6.5C9 8.433 7.433 10 5.5 10C3.567 10 2 8.433 2 6.5V5.5C2 3.567 3.567 2 5.5 2ZM5.5 4C4.67157 4 4 4.67157 4 5.5V6.5C4 7.32843 4.67157 8 5.5 8C6.32843 8 7 7.32843 7 6.5V5.5C7 4.67157 6.32843 4 5.5 4ZM17 11H18C20.2091 11 22 12.7909 22 15V18C22 20.2091 20.2091 22 18 22H17C14.7909 22 13 20.2091 13 18V15C13 12.7909 14.7909 11 17 11ZM17 13C15.8954 13 15 13.8954 15 15V18C15 19.1046 15.8954 20 17 20H18C19.1046 20 20 19.1046 20 18V15C20 13.8954 19.1046 13 18 13H17ZM14.5 2H18.5C20.433 2 22 3.567 22 5.5C22 7.433 20.433 9 18.5 9H14.5C12.567 9 11 7.433 11 5.5C11 3.567 12.567 2 14.5 2ZM14.5 4C13.6716 4 13 4.67157 13 5.5C13 6.32843 13.6716 7 14.5 7H18.5C19.3284 7 20 6.32843 20 5.5C20 4.67157 19.3284 4 18.5 4H14.5Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.d23b3e1cc084272a1862d4bc9358d75c.svg";
export { ForwardRef as ReactComponent };